/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { createTheme, Menu as MantineMenu } from '@mantine/core';

import { item } from './menu.css';

export const menuTheme = createTheme({
  components: {
    Menu: MantineMenu.extend({
      classNames() {
        return {
          item,
        };
      },
    }),
  },
});
